import {
  TICKET_STATUS_CHIP_VARIANT,
  TicketStatusChipVariant,
  TicketStatusEnum
} from '@/types/enums'

export type { TicketStatusChipVariant }

/** All ticket status values, derived from the enum for filter extensibility. */
export const TICKET_STATUS_VALUES = Object.values(TicketStatusEnum)
  .filter((value): value is TicketStatusEnum => typeof value === 'number')
  .sort((a, b) => a - b)

export type TicketStatusI18nKey = `${TicketStatusEnum}`

export type TicketStatusMapped = {
  i18nKey: TicketStatusI18nKey
  value: TicketStatusEnum
  variant: 'secondary' | TicketStatusChipVariant
}

export function getTicketStatusChipVariant(
  status: number
): 'secondary' | TicketStatusChipVariant {
  return mapTicketStatus(status).variant
}

export function getTicketStatusI18nKey(status: number): TicketStatusI18nKey {
  return mapTicketStatus(status).i18nKey
}

/**
 * Maps a ticket status to consistent UI values (i18n key + chip variant).
 * Variants live on the enum module; this helper only resolves them.
 */
export function mapTicketStatus(status: number): TicketStatusMapped {
  const value = status as TicketStatusEnum

  return {
    i18nKey: String(status) as TicketStatusI18nKey,
    value,
    variant: TICKET_STATUS_CHIP_VARIANT[value] ?? 'secondary'
  }
}

/** Pre-mapped statuses for filters/selects — stays in sync with the enum. */
export const TICKET_STATUS_OPTIONS = TICKET_STATUS_VALUES.map(mapTicketStatus)
